export var ContentSizing;
(function (ContentSizing) {
    ContentSizing[ContentSizing["Fixed"] = 0] = "Fixed";
    ContentSizing[ContentSizing["Fluid"] = 1] = "Fluid";
})(ContentSizing || (ContentSizing = {}));
export const postContentStyleParams = {
    'postContent-paddingTop': {
        key: 'postContent-paddingTop',
        defaultValue: 0,
        minValue: 0,
        maxValue: 200,
    },
    'postContent-paddingBottom': {
        key: 'postContent-paddingBottom',
        defaultValue: 0,
        minValue: 0,
        maxValue: 200,
    },
    'postContent-contentSizing': {
        key: 'postContent-contentSizing',
        defaultValue: ContentSizing.Fixed,
        options: (t) => [
            {
                value: ContentSizing.Fixed,
                label: t('layout-tab.post-page.content-sizing-options-fixed'),
            },
            {
                value: ContentSizing.Fluid,
                label: t('layout-tab.post-page.content-sizing-options-fluid'),
            },
        ],
    },
    'postContent-contentWidthInPx': {
        key: 'postContent-contentWidthInPx',
        defaultValue: 740,
        minValue: 0,
        maxValue: 1076,
    },
    'postContent-contentWidthInPercent': {
        key: 'postContent-contentWidthInPercent',
        defaultValue: 56,
        minValue: 0,
        maxValue: 100,
    },
};
//# sourceMappingURL=post-content.wix-params.js.map